import React, { Component } from "react";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/fonts/font-awesome.min.css";
import "../../assets/css/styles.css";
import axios from "axios";
import $ from "jquery";

export class TheatreSidebar extends Component {
  constructor(props) {
    super(props);

   

    // const url = 'hghobs.keshonect.co.ke'

    this.state = {
      module: "",
      profession: "",
      name: "",
      nationality: "",
      age: "",
    };

    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    console.log(localStorage.getItem("accessToken"));
    console.log(localStorage.getItem("currentVisitId"));
    console.log(localStorage.getItem("currentVisitName"));
    console.log(localStorage.getItem("currentVisitNationality"));
    console.log(localStorage.getItem("currentVisitProfession"));
    console.log(localStorage.getItem("currentVisitAge"));
    this.setState({
      age: localStorage.getItem("currentVisitAge"),
      name: localStorage.getItem("currentVisitName"),
      nationality: localStorage.getItem("currentVisitNationality"),
      profession: localStorage.getItem("currentVisitProfession"),
    });

    if (localStorage.getItem("currentVisitName")) {
      $(".patientDetails").show();
    }
    $(".close").on("click", function () {
      $(".modal").hide();
    });
    if (localStorage.getItem("accessToken") == null) {
      $("#loginFirst").show();
      // window.location.href = '/'
    }
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { profession, name, nationality, age } = this.state;
    return (
      <div className="pb-5">
        <div className="sidebar-container pb-5">
          {/* <div className="sidebar-logo">
						Project Name
					</div> 
                    		<Route exact path='' component={PostOpFInal} />
			<Route exact path='/theatre/post/op/observation/scare1' component={PostOpObservationScare1} />
			<Route exact path='/theatre/post/op/observation/scare2' component={PostOpObservationScare2} />
			<Route exact path='' component={PostOpPreliminary} />
			<Route exact path='/theatre/recovery/room/handover' component={Postoprecoveryroomhandover} />
                    
                    */}
          <ul className="sidebar-navigation">
            <li className="header patientDetails" style={displayHidden}>
              <h4>Patient Details</h4>
              <br />
              <b> Name: </b>
              {name}
              <br />
              <b>Nationality: </b>
              {nationality}
              <br />
              <b>Age: </b>
              {age}
              <br />
              <b>Profession: </b>
              {profession}
            </li>
            <li>
              <a href="/theatre/new/surgery">
                <i className="fa fa-plus-square" aria-hidden="true"></i> New
                Surgery
              </a>
            </li>

            <li>
              <a href="/theatre/operating/delivery">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Operating Delivery
              </a>
            </li>

            <li>
              <a href="/theatre/observation/of/mother">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Observation of Mother
              </a>
            </li>
            <li>
              <a href="/theatre/post/operative/orders">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Post
                Operative Orders
              </a>
            </li>
            {/*                        
                        <li>                            
                            <a href="/theatre/post/operative/orders">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> Post Operative Orders
                            </a>
                        </li> */}

            <li>                            
                            <a href="/theatre/post/prelimanry">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> Post Operative Preliminary
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/post/op/observations/care1">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> Post Op Observations care 1
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/post/op/observations/care2">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> Post Op Observations care 2
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/recovery/room/handover">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> Post Op Recovery Room Handover
                            </a>
                        </li>

            <li>                            
                            <a href="/theatre/intra/op/destination">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeDestination
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/electr/surg/unit/anaesthesia">
                                <i className="fa fa-plus-square" aria-hidden="true"></i>IntraOperativeElectrosurgicalUnitAnaesthesia
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/general/timing">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeGeneralTiming
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/medic/given">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeMedicationsgiven
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/positioningcatheter">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativePositioningCatheter
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/specimen/xray/taken">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeSpecimensXraysTaken
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/surgical/prothesis">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeSurgicalProsthesis
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/surgical/team">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeSurgicalTeam
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/swab/instruments">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeSwabInstruments
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/theatre/entry">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeTheatreEntry
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/tournique/drain">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeTourniquetDrain
                            </a>
                        </li>
                        <li>                            
                            <a href="/theatre/intra/op/wound/tranfusion">
                                <i className="fa fa-plus-square" aria-hidden="true"></i> IntraOperativeWoundTransfusion
                            </a>
                        </li>

            <li>
              <a href="/tests/to/be/done">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Tests
                To Be Done In the Lab
              </a>
            </li>
            <li>
              <a href="/external/lab/tests">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                External Lab Tests
              </a>
            </li>
            <li>
              <a href="/ward/round">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Ward
                Round
              </a>
            </li>

            <li>
              <a href="/all/modules/data">
                <i className="fa fa-plus-square" aria-hidden="true"></i> All
                Module Data
              </a>
            </li>
            <li>
              <a href="/send/to/module">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Send To
                Module
              </a>
            </li>

            <li>
              <a href="/discharge/form">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Discharge Patient
              </a>
            </li>

            <li className="header"></li>
          </ul>
        </div>
      </div>
    );
  }
}

export default TheatreSidebar;
